/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'
import * as flagConstants from './constants/flagModal'
import * as hashtagConstants from './constants/hashtagModal'
import * as inactiveSaveSearchConstants from './constants/inactiveSaveSearchModal'
import { CLOSE_MODAL, OPEN_MODAL } from './constants/index'
import * as messageConstants from './constants/messageModal'
import * as metroRentReportConstants from './constants/metroRentReportModal'
import * as multiMessageConstants from './constants/multiMessageModal'
import * as saveSearchConstants from './constants/saveSearchModal'
import * as savedSearchOptionConstants from './constants/savedSearchOptionModal'
import { modalsReducer } from './reducers/index'
import type { ActionTypes } from './types'

const allowedList = [
  OPEN_MODAL,
  CLOSE_MODAL,
  ...Object.values(flagConstants),
  ...Object.values(hashtagConstants).filter((constant) => typeof constant === 'string'),
  ...Object.values(inactiveSaveSearchConstants),
  ...Object.values(messageConstants),
  ...Object.values(metroRentReportConstants),
  ...Object.values(multiMessageConstants),
  ...Object.values(savedSearchOptionConstants),
  ...Object.values(saveSearchConstants),
  // This satisfies makes sure that everything in the whitelist is also used in the reducer
] as const satisfies ReadonlyArray<ActionTypes['type']>

// These 2 lines make sure that every action type that the reducer uses is included in the whitelist
declare const shouldBeEmpty: Exclude<ActionTypes['type'], (typeof allowedList)[number]>
false && (shouldBeEmpty satisfies never)

export const modals = filterActions(modalsReducer, allowedList)
